import gov from './gov.png'
import ncr from './ncr.png'
import is from './is.png'
import nhs from './nhs.png'
import nspcc from './nspcc.png'
import coop from './co-op.png'

export default {
  gov,
  is,
  ncr,
  nhs,
  nspcc,
  coop
}
